import { render, staticRenderFns } from "./SelfSummary.vue?vue&type=template&id=4bee742e&"
import script from "./SelfSummary.vue?vue&type=script&lang=js&"
export * from "./SelfSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports